// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import {} from './axios';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});

// In abstract router mode we must set the initial location explicitly:
/// https://github.com/vuejs/vue-router/issues/729
router.replace('/');



// WEBPACK FOOTER //
// ./src/main.js